// extracted by mini-css-extract-plugin
module.exports = {"modalBackdrop":"ModalConfirmarFechamento_modalBackdrop__3RNDu"};